import { useMemo } from 'react';
import { useLearner } from './useLearner';
import {
  SLOT,
  getBuddyAsset,
  getRandomBuddyAsset,
} from '../lib/buddyManifest';

// useBuddy — the React layer over the buddy manifest (see Docs/Buddy-Service.md).
//
// Reads the active learner's chosen buddy and exposes a typed API. The rotating
// slots (celebrate, encourage, levelUp, xpReward, roundComplete) are resolved
// ONCE per slug via useMemo, so a random pick is held for the component's
// lifetime and does not re-roll on every render. `slug` changes (learner switch)
// re-roll, which is correct.
//
// Components that receive a `buddySlug` prop (e.g. LevelUpCelebration,
// XPRewardModal) should call the pure manifest functions directly instead.
export default function useBuddy() {
  const { data: activeLearner } = useLearner();
  const slug = activeLearner?.buddy?.slug || 'ling';

  return useMemo(() => ({
    slug,
    avatar: getBuddyAsset(slug, SLOT.AVATAR),
    figurine: (view = 1) =>
      getBuddyAsset(slug, view === 2 ? SLOT.FIGURINE_VIEW_2 : SLOT.FIGURINE_VIEW_1),
    celebrate: getRandomBuddyAsset(slug, SLOT.CELEBRATE),
    encourage: getRandomBuddyAsset(slug, SLOT.ENCOURAGE),
    levelUp: getRandomBuddyAsset(slug, SLOT.LEVEL_UP),
    xpReward: getRandomBuddyAsset(slug, SLOT.XP_REWARD),
    roundComplete: getRandomBuddyAsset(slug, SLOT.ROUND_COMPLETE),
  }), [slug]);
}
